// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1gGWy","content":"styles_content__2j_lJ","checkbox":"styles_checkbox__CFwiS","checkboxLabel":"styles_checkboxLabel__1gvrk"};